import { useContext } from 'react';

import Hyperlink from '@ingka/hyperlink';
import InlineMessage from '@ingka/inline-message';
import Loading, { LoadingBall } from '@ingka/loading';
import errorMessageIcon from '@ingka/ssr-icon/paths/incorrect';
import {
  DelayedResult,
  getLocaleSetting,
  hasTranslation,
  t,
  Trans,
} from '@onlinepayments/payments-library';
import { Redirect } from 'react-router-dom';

import ProductListContainer from '../../components/ProductList';
import { Card } from '../../components/toolkit';
import { LoadingState } from '../../enums/LoadingState';
import { Path } from '../../enums/Path';
import { OrderDetailsContextProvider } from '../../OrderDetailsContext';
import { PayorderContext } from '../../PayorderContext';

import OrderDetails from './OrderDetails';
import successGif from './success.gif';

import './ConfirmationPage.scss';

const ConfirmationPage = () => {
  const {
    contextState: {
      orderDetails: { loadingState, response },
      payorderContext: { contextId: payorderContextId },
    },
  } = useContext(PayorderContext);
  const {
    faqUrl,
    contactUsUrl,
    customerServicePhoneNumber,
    hideOpeningHours,
    payment: { showProductListOnConfirmationPage },
  } = getLocaleSetting();

  if (!payorderContextId) {
    return <Redirect to={Path.ValidateOrder} />;
  }

  return (
    <div className="OrderConfirmationPage text-s" data-testid="OrderConfirmationPage">
      <Card>
        <DelayedResult
          alt={
            <div>
              <div className="success-image-container">
                <img src={successGif} alt={t('payment.order_confirmation_image_alt_text')} />
              </div>
              <h2 className="mb-100 text-center">{t('order.order_confirmation_header')}</h2>
            </div>
          }
        />
        {loadingState === LoadingState.Failure && (
          <InlineMessage
            role="alert"
            variant="negative"
            ssrIcon={errorMessageIcon}
            body={t('generic_error_message')}
          />
        )}
        {loadingState === LoadingState.Pending && (
          <Loading text={t('loading_spinner_label')}>
            <LoadingBall />
          </Loading>
        )}
        {loadingState === LoadingState.Success && response && (
          <OrderDetails details={response} hideOpeningHours={!!hideOpeningHours} />
        )}
      </Card>
      {showProductListOnConfirmationPage && (
        <Card>
          <OrderDetailsContextProvider order={response}>
            <ProductListContainer />
          </OrderDetailsContextProvider>
        </Card>
      )}
      {(hasTranslation('order.delivery_date_customer_service_text') ||
        customerServicePhoneNumber) && (
        <div data-testid="ProcessingOrderInfo">
          <Card>
            <p>{t('order.processing_order_info')}</p>

            <p className="mt-100">
              <Trans
                id="order.delivery_date_customer_service_text"
                placeholders={{
                  faqLink: (
                    <Hyperlink text={t('order.faq_link_text')} newWindow={true} url={faqUrl} />
                  ),
                  contactUsLink: (
                    <Hyperlink
                      text={t('order.contact_us_link_text')}
                      newWindow={true}
                      url={contactUsUrl}
                    />
                  ),
                }}
              />
              {!faqUrl && !contactUsUrl && <span> {customerServicePhoneNumber}.</span>}
            </p>
          </Card>
        </div>
      )}
    </div>
  );
};

export default ConfirmationPage;
